import DrawingMode from '../interface/drawingMode';
import consts from '../lib/consts';

const { drawingModes } = consts;
const components = consts.componentNames;

/**
 * NormalMode class
 * @class
 * @ignore
 */
class NormalMode extends DrawingMode {
  constructor() {
    super(drawingModes.NORMAL);
  }

  /**
   * start this deletion mode
   * @param {Graphics} graphics - Graphics instance
   * @override
   */
  start(graphics) {
    const normal = graphics.getComponent(components.NORMAL);
    normal.start();
  }

  /**
   * stop this deletion mode
   * @param {Graphics} graphics - Graphics instance
   * @override
   */
  end(graphics) {
    const normal = graphics.getComponent(components.NORMAL);
    normal.end();
  }
}

export default NormalMode;
